 
const ESTILO_DOCUMENTO = `<style>
    html, body { margin: 0; padding: 0; height: auto !important; max-height: none !important; }
    html, body, * { overflow: visible !important; }
</style>`;

export function montarSrcDocImpressao(html) {
    if (!html) return html;
 
    if (/<head[^>]*>/i.test(html))
        return html.replace(/<head[^>]*>/i, (head) => `${head}${ESTILO_DOCUMENTO}`); 
    return ESTILO_DOCUMENTO + html;
}
